import Card from './Card';
import Chart from './Chart';
import Recents from './Recents';

function Overview({ payments }) {
    return (
        <div className="space-y-5 pt-5">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <Card
                    title="Total Disbursed"
                    disburseData={{ todayTotal: payments?.totalDisbursements }}
                    accent="blue"
                />
                <Card
                    title="Total Repayments"
                    disburseData={{ todayTotal: payments?.totalRepayments }}
                    accent="green"
                />
                <Card
                    title="Disbursed This Month"
                    disburseData={{ todayTotal: payments?.totalDisbursementThisMonth }}
                    accent="amber"
                />
                <Card
                    title="Repayments This Month"
                    disburseData={{ todayTotal: payments?.totalRepaymentThisMonth }}
                    accent="purple"
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                <div className="col-span-3">
                    <Chart
                        yearDisbursed={payments?.yearDisbursed}
                        yearRepaid={payments?.yearRepaid}
                    />
                </div>
                <div className="col-span-2">
                    <Recents recPayments={payments?.recPayments} />
                </div>
            </div>
        </div>
    );
}

export default Overview;
